export const trimStringEndingPunctuation = (string: string): string => {
  return string.replace(/[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]+$/, '');
};
